module.exports = __webpack_public_path__ + "static/media/Respiration.9fa5036f.png";